module.exports = __webpack_public_path__ + "img/headphones.4f972ab7.svg";